import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { PRProcessTable } from '@app/components/apps/PRProcess/PRProcessTable';

const AllPRProcesses: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-product-registration-process');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/product-registration-processes',
            breadcrumbName: 'Product Registrations Processes',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Process',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Product Registration Processes</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PRProcessTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPRProcesses;
